import Alpine from "alpinejs"

Alpine.data("dialog", () => ({
    get open() {
        return this.$refs.dialog.open
    },
    showModal() {
        this.$refs.dialog.showModal()
        this.$refs.dialog.classList.remove("overflow-hidden")
        document.body.classList.add("overflow-hidden")
    },
    closeModal() {
        // Find and reset any videos in the dialog
        const videoComponents = this.$el.querySelectorAll('[x-data^="video"]')
        videoComponents.forEach((component) => {
            if (component.__x && component.__x.$data) {
                // Reset the playing state
                component.__x.$data.playing = false

                // Find and handle HTML5 video elements
                const videoElement = component.querySelector("video")
                if (videoElement) {
                    videoElement.pause()
                    videoElement.currentTime = 0
                }
            }
        })

        // Handle YouTube iframes
        const youtubeIframes = this.$el.querySelectorAll('iframe[src*="youtube.com"]')
        youtubeIframes.forEach((iframe) => {
            const src = iframe.src
            iframe.src = src.replace("autoplay=1", "autoplay=0")
        })

        // Handle Vimeo iframes
        const vimeoIframes = this.$el.querySelectorAll('iframe[src*="vimeo.com"]')
        vimeoIframes.forEach((iframe) => {
            const src = iframe.src
            iframe.src = src.replace("autoplay=1", "autoplay=0")
        })

        this.$refs.dialog.close()
        this.$refs.dialog.classList.add("overflow-hidden")
        document.body.classList.remove("overflow-hidden")
    },
}))
